import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { Driver } from '../../store/ducks/freight/types';
export default function useUpdateDriver() {
  const [loading, setLoading] = useState(false);

  async function execute({
    data,
    driverId,
    callback,
  }: {
    data: Partial<Driver>;
    driverId: string;
    callback?: any;
  }) {
    try {
      setLoading(true);
      const response = await api.put(`v1/backoffice/drivers/${driverId}`, {
        status: data.status,
        email: data.email,
        cpf: data.cpf,
        rg: data.rg,
        phoneNumber: data.phoneNumber,
        birthDate: data.birthDate,
        username: data.username,
      });

      if (response.status === 200) {
        toast.success(ToastMessages.driver.success.update);
        if (callback) {
          callback();
        }
      }
    } catch (error: any) {
      const errorData = error.response.data;
      if (errorData.message)
        toast.error(`Erro de validação: ${errorData.message}`);
      else toast.error(ToastMessages.driver.error.update);
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
